function initKomfyScrollSlider(grid) {
  if (!grid) return;

  // Only activate if there's content to scroll
  if (grid.scrollWidth <= grid.clientWidth) return;

  // Remove scroll snap so it flows freely
  grid.style.scrollSnapType = 'none';

  var manualOffset = 0;
  var lastAutoScroll = 0;
  var isManualScrolling = false;
  var manualTimeout = null;

  // Touch direction detection
  var touchStartX = 0;
  var touchStartY = 0;
  var directionLocked = false;

  grid.addEventListener('touchstart', function(e) {
    var touch = e.touches[0];
    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
    directionLocked = false;
    clearTimeout(manualTimeout);
  }, { passive: true });

  grid.addEventListener('touchmove', function(e) {
    if (directionLocked) return;

    var touch = e.touches[0];
    var dx = Math.abs(touch.clientX - touchStartX);
    var dy = Math.abs(touch.clientY - touchStartY);

    // Need at least 10px movement to decide direction
    if (dx < 10 && dy < 10) return;

    if (dx > dy * 1.5) {
      // Horizontal swipe — take over
      isManualScrolling = true;
      directionLocked = true;
    } else {
      // Vertical scroll — don't interfere
      directionLocked = true;
    }
  }, { passive: true });

  grid.addEventListener('touchend', function() {
    if (isManualScrolling) {
      manualOffset = grid.scrollLeft - lastAutoScroll;
    }
    manualTimeout = setTimeout(function() {
      isManualScrolling = false;
      directionLocked = false;
    }, 100);
  }, { passive: true });

  // Detect manual horizontal scroll (mouse wheel etc)
  grid.addEventListener('scroll', function() {
    if (isManualScrolling) return;
    manualOffset = grid.scrollLeft - lastAutoScroll;
  }, { passive: true });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        window.addEventListener('scroll', onScroll, { passive: true });
      } else {
        window.removeEventListener('scroll', onScroll);
      }
    });
  }, { threshold: 0 });

  observer.observe(grid);

  function onScroll() {
    if (isManualScrolling) return;

    var rect = grid.getBoundingClientRect();
    var viewportHeight = window.innerHeight;

    // Start scrolling only when section is 60% into view
    var startPoint = viewportHeight * 0.6;
    var progress = (startPoint - rect.top) / (startPoint + rect.height);
    progress = Math.max(0, Math.min(1, progress));

    // Max scroll = total scrollable width
    var maxScroll = grid.scrollWidth - grid.clientWidth;
    lastAutoScroll = progress * maxScroll * 0.5;

    // Clamp final position to valid range
    var targetScroll = Math.max(0, Math.min(maxScroll, lastAutoScroll + manualOffset));
    grid.scrollLeft = targetScroll;

    // Reset offset if it's pushing us out of bounds
    if (lastAutoScroll + manualOffset < 0) {
      manualOffset = -lastAutoScroll;
    } else if (lastAutoScroll + manualOffset > maxScroll) {
      manualOffset = maxScroll - lastAutoScroll;
    }
  }
}

(function() {
  document.querySelectorAll('.komfy-ingredients-grid, .komfy-pdp-reviews__grid').forEach(initKomfyScrollSlider);
})();
